import { IconProps } from "models"
import { ICON_DEFAULT_SIZE } from "utils/constants"

const BikeIcon: React.FC<IconProps> = ({
	className = "",
	style = null,
	color = "currentColor",
	size = ICON_DEFAULT_SIZE,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 388 388"
			className={className}
			style={style}
			aria-hidden="true"
		>
			<path
				fill={color}
				stroke={color}
				d="M307.6 153.199c-11.2 0-22 2.4-32 6.4l-13.6-26.4v-42c0-2.4-1.6-4.8-4-5.6l-32-12c-3.2-1.2-6.4.4-7.6 3.6-1.2 3.2.4 6.4 3.6 7.6l28.4 10.4v34H133.2v-11.6h14.4c3.2 0 6-2.8 6-6s-2.8-6-6-6h-37.2c-3.2 0-6 2.8-6 6s2.8 6 6 6h10.8v16.4l-11.6 25.2c-8.8-3.6-18.8-5.6-28.8-5.6-44.4 0-80.8 36-80.8 80.8s36 80.8 80.8 80.8c42.4 0 77.2-33.2 80.4-74.8h26c2 0 3.6-.8 4.8-2.4l62.8-90.8 10 18.8c-22.8 13.6-38 39.2-38 68 0 44.4 36 80.8 80.8 80.8s80.8-36 80.8-80.8-36-80.8-80.8-80.8zm-226.8 149.6c-38 0-68.8-30.8-68.8-68.8s30.8-68.8 68.8-68.8c8.4 0 16.4 1.6 23.6 4.4l-29.2 62v.4c-.4.8-.4 1.2-.4 2v.4c0 .8 0 1.2.4 2v.4c0 .4 0 .4.4.8 0 .4.4.4.8.8v.4c.4.4 1.2.8 1.6 1.2h.4c.8.4 1.2.4 2 .4h68.4c-2.8 34.8-32 62.4-68 62.4zm9.2-74.8 25.2-53.2c18.8 10.8 32 30.4 34 53.2H90zm94 0h-23.2c-2-27.6-18-51.2-40.8-64.4l10.8-22.8H244l-60 87.2zm123.2 74.8c-38 0-68.8-30.8-68.8-68.8 0-24.4 12.8-45.6 32-58l31.6 60.8c1.2 2 3.2 3.2 5.2 3.2.8 0 2-.4 2.8-.8 2.8-1.6 4-5.2 2.4-8l-31.6-60.8c8.4-3.2 17.2-5.2 26.4-5.2 38 0 68.8 30.8 68.8 68.8s-30.8 68.8-68.8 68.8z"
			/>
		</svg>
	)
}

export default BikeIcon
